import { takeEvery, takeLatest, put, call, select } from "redux-saga/effects";
import { delay } from "redux-saga";

import * as action from "./actions";
import { MetricDataEndpointEnum } from "./actions";
import * as api from "../../apis/";
import {
  getViewContext,
  globalFilters,
  currentMerchantName
} from "../Analytics/selectors";
import { getUserContext } from "../User/selectors";
import { sendGAEvent } from "../common/google_analytics";

interface MetricDataPayload extends IPayload {
  endpoint: action.MetricDataEndpointEnum;
}
//debounce metric queries: https://stackoverflow.com/questions/36602534/correct-way-to-throttle-http-calls-based-on-state-in-redux-and-react
export function* getMetricData(request: MetricDataPayload) {
  try {
    yield put(action.clearMetricData());
    yield call(delay, 500);
    yield put(action.setMetricDataLoading(true));
    let response;
    let filters = yield select(globalFilters);
    if (request.endpoint == MetricDataEndpointEnum.ITEM_METRIC) {
      response = yield call(api.item_metric_visualization_data, {
        ...request.payload,
        filters
      });
    } else if (request.endpoint == MetricDataEndpointEnum.FLYER_METRIC) {
      response = yield call(api.flyer_metric_visualization_data, {
        ...request.payload,
        filters
      });
    } else if (request.endpoint == MetricDataEndpointEnum.SPEND_METRIC) {
      response = yield call(api.flyer_spend_data, request.payload);
    }
    yield put(action.setMetricData(response));
    yield put(action.setMetricDataLoading(false));
    let Window = <any>window;
    const userContext = yield select(getUserContext);
    const viewContext = yield select(getViewContext);
    const merchantName = yield select(currentMerchantName);
    sendGAEvent("Analytics", "Load View", merchantName, {
      ...userContext,
      ...viewContext
    });
  } catch (e) {
    switch (request.endpoint) {
      case MetricDataEndpointEnum.ITEM_METRIC:
        console.log("GET ITEM METRIC DATA FAILED");
        break;
      case MetricDataEndpointEnum.FLYER_METRIC:
        console.log("GET FLYER METRIC DATA FAILED");
        break;
      case MetricDataEndpointEnum.SPEND_METRIC:
        console.log("GET SPEND METRIC DATA FAILED");
        break;
    }
    console.log(e);
    yield put(action.setMetricDataLoading(false));
    yield put(action.setMetricData([]));
  }
}

export function* watchGetMetricData() {
  yield takeLatest(action.GET_METRIC_DATA, getMetricData);
}

export function* getFlyers(request: any) {
  try {
    yield put(action.setFlyersLoading(true));
    let response = yield call(api.fetchFlyers, request.payload.flyerRunIds);
    yield put(action.setFlyers(response));
    yield put(action.setFlyersLoading(false));
    if (request.payload.setDefault || response.length === 1)
      yield put(action.setSelectedFlyerId(response[0].flyer_id));
  } catch (e) {
    console.log(e);
    yield put(action.setFlyersLoading(false));
    yield put(action.getFlyersFailure());
  }
}

export function* watchGetFlyers() {
  yield takeLatest(action.GET_FLYERS, getFlyers);
}

export function* getFlyerItems(request: any) {
  try {
    yield put(action.clearFlyerItems());
    yield put(action.setFlyerItemsLoading(true));
    const filters = yield select(globalFilters);
    let response = yield call(
      api.fetchFlyerItems,
      request.payload.flyerId,
      request.payload.metrics,
      request.payload.startDate,
      request.payload.endDate,
      filters,
      request.payload.groupBy
    );
    yield put(action.setFlyerItemsLoading(false));
    yield put(action.setFlyerItems(response));
  } catch (e) {
    console.log(e);
    yield put(action.setFlyerItemsLoading(false));
    yield put(action.getFlyerItemsFailure());
  }
}

export function* watchGetFlyerItems() {
  yield takeLatest(action.GET_FLYER_ITEMS, getFlyerItems);
}

export function* getToplineMetrics(request: IPayload) {
  try {
    yield put(action.setToplineMetricsLoading(true));
    let filters = yield select(globalFilters);
    let response = yield call(api.fetchToplineMetrics, {
      ...request.payload,
      filters
    });
    yield put(action.addToplineMetrics(response));
    yield put(action.setToplineMetricsLoading(false));
  } catch (e) {
    console.log(e);
    yield put(action.setToplineMetricsLoading(true));
    yield put(action.getToplineMetricsFailure());
  }
}

export function* watchGetToplineMetrics() {
  yield takeEvery(action.GET_TOPLINE_METRICS, getToplineMetrics);
}

export function* getSFMLUrl() {
  const state = yield select();
  const { merchant_id } = state.analytics;
  const { selectedPublicationId } = state.analytics_metric;
  const { selectedFlyerId } = state.analytics_metric;
  const flyer = state.analytics_metric.flyers.find(
    (flyer: any) => flyer.flyer_id === parseInt(selectedFlyerId, 10)
  );
  if (flyer) {
    return `/storefronts/${selectedPublicationId}/${selectedFlyerId}/${flyer.hashed_key}?merchant_id=${merchant_id}`;
  }

  return null;
}

export function* getSfmlData() {
  try {
    yield put(action.setSFMLErrorMessage(null));
    yield put(action.saveSFMLData(null));

    const url = yield call(getSFMLUrl);
    const data = yield call(api.fetchSFML, url);
    yield put(action.saveSFMLData(data));
  } catch (e) {
    yield put(action.setSFMLErrorMessage("Preview is not available"));
  }
}

export function* watchGetSfmlData() {
  yield takeLatest(action.GET_SFML_DATA, getSfmlData);
}



// WEBPACK FOOTER //
// ./client/modules/AnalyticsMetric/sagas.ts